import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { worlds } from '../../data/worlds';
import { foxCutout } from '../../lib/brandAssets';
import { pricing } from '../../lib/pricing';
import { TryFreeLink } from '../TryFreeLink';

/** Worlds not already shown higher up the homepage. */
const TILE_WORLDS = ['Ocean Secrets', 'Tiny Worlds', 'Long Ago'];
const tileWorlds = TILE_WORLDS.map(name => worlds.find(world => world.name === name)).filter((world): world is (typeof worlds)[number] => Boolean(world));
const tilts = ['-rotate-3', 'rotate-1 -translate-y-2', 'rotate-3'];

/** Two image tiles to the deeper pages, then the closing call to action. */
export function HomeTiles() {
  return <>
      <div className="mt-16 grid gap-5 md:mt-24 md:grid-cols-2" data-id="element-227" data-mp="k83vzwvmo6o3">
        <Link to="/worlds" className="group flex flex-col gap-6 rounded-[28px] bg-lavender-soft p-6 transition-transform duration-200 ease-out hover:-translate-y-1 sm:p-8" data-id="element-228" data-mp="39ypdkk4y58km">
          <div data-id="element-229" data-mp="22xmfpg5y1fp5">
            <h2 className="font-display text-[28px] leading-tight text-ink md:text-[32px]" data-id="element-230" data-mp="22x2yy2s14xcp">
              Explore {pricing.worldCount} worlds
            </h2>
            <p className="mt-2 text-[17px] text-ink-soft" data-id="element-231" data-mp="1sywzrsxly5bj">From deep-sea secrets to tiny hidden worlds.</p>
          </div>
          <div className="grid grid-cols-3 gap-2 sm:gap-3" data-id="element-232" data-mp="1xwf6rds2eagw">
            {tileWorlds.map((world, i) => <div key={world.slug} className={`rounded-2xl bg-cream-field p-1.5 shadow-card sm:p-2 ${tilts[i]}`} data-id="element-233" data-mp="1j7slywjo4qia" data-mpi={i}>
                <img src={world.art} alt={world.alt} loading="lazy" decoding="async" width={world.width} height={world.height} className="aspect-square w-full object-contain" data-id="element-234" data-mp="1o0lqbjb85wtu" />
              </div>)}
          </div>
          <span className="mt-auto inline-flex items-center gap-2 font-display text-[18px] text-ink underline decoration-coral decoration-[3px] underline-offset-[6px]" data-id="element-235" data-mp="157rirafxl6zn">
            See the worlds
            <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-236" data-mp="hcg4jypkwr6i" />
          </span>
        </Link>

        <Link to="/parents" className="group relative flex min-h-[320px] flex-col overflow-hidden rounded-[28px] bg-sun p-6 pb-32 transition-transform duration-200 ease-out hover:-translate-y-1 sm:p-8 sm:pb-8" data-id="element-237" data-mp="7fjtbl8apqy9">
          <h2 className="max-w-[20rem] font-display text-[26px] leading-tight text-ink md:text-[30px]" data-id="element-238" data-mp="105aak35858yl">
            Made for curious kids. Designed with parents in mind.
          </h2>
          <p className="mt-3 max-w-[17rem] text-[17px] text-ink" data-id="element-239" data-mp="q6kt2bh8pqiv">
            Ad-free adventures, separate child profiles, and parent-protected settings.
          </p>
          <span className="mt-auto inline-flex items-center gap-2 pt-5 font-display text-[18px] text-ink underline decoration-ink decoration-[3px] underline-offset-[6px]" data-id="element-240" data-mp="3aw0d8nlyegzj">
            For parents
            <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-241" data-mp="1vd2gjenf3vzw" />
          </span>
          <img src={foxCutout.src} alt="" loading="lazy" decoding="async" width={foxCutout.width} height={foxCutout.height} className="pointer-events-none absolute -bottom-2 -right-2 w-[130px] object-contain sm:w-[160px]" data-id="element-242" data-mp="20akr19h32ja0" />
        </Link>
      </div>

      <section aria-labelledby="closing-heading" className="mt-16 text-center md:mt-20" data-id="element-243" data-mp="2j2nastp0ufoh">
        <h2 id="closing-heading" className="font-display text-[30px] leading-tight tracking-tight text-ink md:text-[40px]" data-id="element-244" data-mp="2j0u5piu243il">
          See their first discovery.
        </h2>
        <div className="mt-6 flex flex-col items-center" data-id="element-245" data-mp="oqgnwxmrmagc">
          <TryFreeLink data-id="element-246" data-mp="tmxc1rtysotf" />
        </div>
      </section>
    </>;
}